import React from 'react'
import { Link } from 'gatsby';
import './rw_link.css'

const RWLink = ({ to, title }) => (
    <Link to={to} className="link" activeStyle={{color: "gold"}} >{title}</Link>
)

export default RWLink